import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';

import MiscFeeSettingsFeesContainer from './containers/Fees/MiscFeeSettingsFeesContainer';
import MiscFeeSettingsOfficeContainer from './containers/Offices/MiscFeeSettingsOfficeContainer';

function MiscellaneousFeeSettings({ match, pathName }) {
  const permissions = getJson('permissions');
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              {Acl(permissions, ['VIEW MISCELLANEOUS FEES SETTINGS OFFICES']) && (
                <li className="nav-item">
                  <Link
                    to="/miscellaneous-fees/settings/office"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('/miscellaneous-fees/settings/office') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Office
                  </Link>
                </li>
              )}
              {Acl(permissions, ['VIEW MISCELLANEOUS FEES SETTINGS FEES']) && (
                <li className="nav-item">
                  <Link
                    to="/miscellaneous-fees/settings/fees"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf('miscellaneous-fees/settings/fees') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Fees
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => {
              if (Acl(permissions, ['VIEW MISCELLANEOUS FEES SETTINGS OFFICES'])) {
                return <Redirect to={`${match.path}/office`} />
              }
              if (Acl(permissions, ['VIEW MISCELLANEOUS FEES SETTINGS FEES'])) {
                return <Redirect to={`${match.path}/fees`} />
              }

              return <Redirect to={`${match.path}`} />
            }}
          />
          {Acl(permissions, ['VIEW MISCELLANEOUS FEES SETTINGS OFFICES']) && (
            <Route
              path={`${match.path}/office`}
              component={MiscFeeSettingsOfficeContainer}
            />
          )}
          {Acl(permissions, ['VIEW MISCELLANEOUS FEES SETTINGS FEES']) && (
            <Route
              path={`${match.path}/fees`}
              component={MiscFeeSettingsFeesContainer}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

MiscellaneousFeeSettings.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(MiscellaneousFeeSettings);
